import { Flex, Kbd } from '@chakra-ui/react';
import { KText } from '@/ui-library/components/text/KText';

export const SearchBottomBar = () => {
  return (
    <Flex
      p="16px"
      borderTop="1px solid"
      borderColor="secondary-100"
      alignItems="center"
    >
      <Flex alignItems="center" gap="4px">
        <KText color="secondary-500" as="span">
          Press{' '}
        </KText>
        <Kbd bg="secondary-50" color="secondary-500" borderBottomWidth="1px">
          ⌘
        </Kbd>{' '}
        <Kbd bg="secondary-50" color="secondary-500" borderBottomWidth="1px">
          K
        </Kbd>{' '}
        <KText as="span" color="secondary-500">
          any time to search
        </KText>
      </Flex>
    </Flex>
  );
};
